import { combineReducers, configureStore } from "@reduxjs/toolkit";
import setManualTypeReducer from "./slice/manualTypeSlice";
import setPlatformTypeReducer from "./slice/platformTypeSlice";
import setSideMenuReducer from "./slice/sideMenuSlice";

const rootReducer = combineReducers({
  manualTypeChecker: setManualTypeReducer,
  platformTypeChecker: setPlatformTypeReducer,
  sideMenuChecker: setSideMenuReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
